<template>
  <div>
    <div v-if="infraElementsHasData">
      <b-col lg="6" md="12" sm="12"
        v-for="(componentObject, index) in groupByZoneName"
        :key="index"
      >
        <b-card :title="$t(categoryNamesForInfraElements[index])">
          <InfraNoTraffic
          :categoryNames="deviceTypeNamesForInfraElements"
          :series="componentObject"
          @infra-click="handleClickEvent"
          @xtend-click="handleXtendClickEvent"
          ></InfraNoTraffic>
        </b-card>
      </b-col>
  </div>
    <SpinnerCmpt v-else-if="!loadedInfraElements"></SpinnerCmpt>
    <div v-else>
      {{ $t("No Data Available") }}
    </div>
  </div>
</template>

<script>
import InfraNoTraffic from '@/xvisor/components/infra/InfraNoTraffic.vue';
import SpinnerCmpt from '@/xvisor/components/SpinnerCmpt.vue';

export default {
  components: {
    InfraNoTraffic,
    SpinnerCmpt,
  },
  props: {
    urls: {
      type: Object,
      required: true,
    },
    timeRange: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.httpGet();
  },
  watch: {
    timeRange() {
      this.resetData();
      this.httpGet();
    },
  },
  data() {
    return {
      loadedInfraElements: false,
      infraElements: [],
    };
  },
  computed: {
    httpParams() {
      return {
        params: {
          start: this.timeRange.start.toISOString(),
          end: this.timeRange.end.toISOString(),
        },
      };
    },
    infraElementsHasData() {
      return this.infraElements
        && this.infraElements.length > 0;
    },
    categoryNamesForInfraElements() {
      const categories = this.infraElements
        ? [...new Set(this.infraElements.map((node) => node.zoneName))] : [];
      return categories;
    },
    deviceTypeNamesForInfraElements() {
      const deviceTypes = this.infraElements
        ? [...new Set(this.infraElements.map((node) => node.deviceType))] : [];
      return deviceTypes;
    },
    groupByZoneName() {
      const groupedByZoneName = this.infraElements
        ? Object.values(
          this.infraElements.reduce((acc, node) => {
            if (!acc[node.zoneName]) {
              acc[node.zoneName] = [];
            }
            acc[node.zoneName].push(node);
            return acc;
          }, {}),
        )
        : [];
      return groupedByZoneName;
    },
  },
  methods: {
    resetData() {
      this.loadedInfraElements = false;
      this.infraElements = [];
    },
    httpGet() {
      this.resetData();
      this.$http
        .get(this.urls.infraElementsUrl, {
          params: {
            start: this.timeRange.start.toISOString(),
            end: this.timeRange.end.toISOString(),
          },
        })
        .then((unconnectedNodes) => { this.infraElements = unconnectedNodes.data; })
        .finally(() => { this.loadedInfraElements = true; });
    },
    handleClickEvent(infraElem) {
      this.$emit('infra-click', infraElem);
    },
    handleXtendClickEvent(xtendElem) {
      this.$emit('xtend-click', xtendElem);
    },
  },
};
</script>
